import React from 'react'
import { Link } from 'react-router'
import { config } from 'config'

class Header extends React.Component {
  render () {
    const { pathname } = this.props;
    return (
      <header className="header">
        <Link to="/" className="logo">
          <div className="logo-background-skew"></div>
          <span className="logo-icon-white"></span>
          <span className="logo-name-white"></span>
          <span className="logo-beta"></span>
        </Link>
      </header>
    )
  }
}

export default Header



// WEBPACK FOOTER //
// ../components/Header.js